function isFuture(date) {
    return new Date(date).getTime() > Date.now();
}
export { isFuture };
